export default "__VITE_ASSET__Cb8sf7Sh__"